




import {Vue, Component} from 'vue-property-decorator';

@Component
export default class NotFound extends Vue {
  get title(): string {
    return '404：' + this.$route.path;
  }
}
